import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../../components/grid/headerTemplate/headerTemplate.vue";

export default {
	extends: gridClientBase,
	components: {},

	data: function() {
		return {
			loading: false,
			savePendingRequest: null

			// items: []
		};
	},

	created() {
		this.getData();
		var newItem = {
			id: 0,
			name: "",
			description: "",
			is_trailer: false,
			counter_id: 4,
			box_drive_icon: "",
			box_stop_icon: "",
			box_still_icon: ""
		};
		this.defaultAddRow = newItem;
		this.sort = [{ field: "name", dir: "asc" }];
	},

	/* metodi */
	methods: {
		saveData: function() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = api
					.postCategoriesData(this.createdItems, this.updatedItems, this.deletedItems)
					.then(res => {
						self.createdItems = [];
						self.updatedItems = [];
						self.deletedItems = [];

						self.isInEditMode = false;
						self.getData();
					})
					.catch(err => {
						console.log("KO" + err);
					})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},

		getData: function() {
			var self = this;
			this.loading = true;

			this.getCategories(self);
		},

		getCategories: function(self) {
			api.getCategoriesData().then(res => {
				self.loading = false;
				self.items = res.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						description: item.description,
						is_trailer: item.is_trailer,
						counter_id: item.counter_id,
						box_drive_icon: item.box_drive_icon,
						box_stop_icon: item.box_stop_icon,
						box_still_icon: item.box_still_icon
					};
				});
			});
		},

		switchEditMode: function() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},

	/* visualizzazione risultati */
	computed: {
		columns: function() {
			return [
				{
					field: "name",
					title: "nome",
					width: "240",
					minResizableWidth: "100",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "description",
					title: "descrizione",
					width: "240",
					minResizableWidth: "100",
					cell: "myCellTemplateNotRequired",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "is_trailer",
					title: "rimorchio",
					className: "text-center",
					width: "120",
					minResizableWidth: "120",
					cell: "myCellTemplate",
					format: "boolean",
					filter: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					filterable: true
				},
				{
					field: "counter_id",
					title: "unità di misura",
					width: "60",
					minResizableWidth: "60",
					headerCell: "myHeaderTemplate"
				},
				{
					field: "box_drive_icon",
					title: "Movimento",
					cell: "myCellTemplate",
					format: "image",
					width: "100",
					minResizableWidth: "100",
					headerCell: "myHeaderTemplate",
					sortable: false
				},
				{
					field: "box_stop_icon",
					title: "Fermo",
					cell: "myCellTemplate",
					format: "image",
					width: "100",
					minResizableWidth: "100",
					headerCell: "myHeaderTemplate",
					sortable: false
				},
				{
					field: "box_still_icon",
					title: "Inattività",
					cell: "myCellTemplate",
					format: "image",
					width: "100",
					minResizableWidth: "100",
					headerCell: "myHeaderTemplate",
					sortable: false
				},
				{
					cell: cellDeleteCommand,
					width: "45",
					minResizableWidth: "45",
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
			];
		}
	}
};
